import {Component, EventEmitter, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'confirmation-dialog',
    templateUrl: './confirmation.dialog.html',
    styleUrls: ['./all-dialog.scss']
})
export class ConfirmationDialog implements OnInit {
    public result = new EventEmitter();

    constructor(
        public dialogRef: MatDialogRef<ConfirmationDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
    }

    async ngOnInit(): Promise<void> {

    }

    closeDialog() {
        this.dialogRef.close();
    }

    ok() {
        this.result.emit(true);
        this.closeDialog();
    }
}
